import { ChangeEventHandler } from "react";
import "./Check.scss";
import { useEffect, useState, useRef } from "react";
interface CheckProps {
  label?: string;
  onChange?: ChangeEventHandler<HTMLInputElement> | any;
  active?: boolean;
  value?: any;
  pre?: boolean;
}

const Check: React.FC<CheckProps> = ({
  label,
  onChange,
  active,
  value,
  pre,
}) => {
  const [defaultValue, setDefaultValue] = useState<boolean>(false)
  useEffect(() => {
    setDefaultValue(pre || false)
  }, [pre])
  return (
    <>
      <label className={!active ? "custom-checkbox" : "custom-checkbox active"}>
        <input
          type="checkbox"
          onChange={onChange}
          value={value}
          defaultChecked={pre}
          checked={pre}
        />
        <span className="checkmark"></span>
        {label}
      </label>
    </>
  );
};

export default Check;
